import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ICondition } from 'app/models/Placement/CredOneCompliance';
import { missingField } from 'app/constants';
import { createAssetFormulaData, createFieldsData, createSubAssetData } from './helper';
import { conditionTableHeader } from './config';

const useConditionTableStyles = makeStyles()(() => ({
  header: {
    color: '#333333',
    background: '#F5F5F5',
    fontSize: '14px !important',
  },
  row: {
    fontSize: '14px',
  },
  foundValue: {
    fontSize: '14px',
    width: '150px',
  },
  headerDivider: {
    content: '""',
    position: 'absolute',
    right: 0,
    width: '1px',
    height: '18px',
    backgroundColor: '#CCCCCC',
    top: '14px',
  },
}));

export default function ConditionTable({ conditionItem }: { conditionItem: ICondition }) {
  const { classes } = useConditionTableStyles();
  let conditionDataSetup = [];

  const initiateConditionDataSetup = () => {
    const subAssetResult = createSubAssetData(conditionItem) ?? [];
    const fieldResult = createFieldsData(conditionItem) ?? [];
    const assetFormulas = createAssetFormulaData(conditionItem) ?? [];
    return [].concat(subAssetResult, fieldResult, assetFormulas);
  };

  conditionDataSetup = initiateConditionDataSetup();

  return (
    <Box sx={{ background: 'white', padding: '12px' }}>
      <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow className={classes.header}>
              <TableCell></TableCell>
              {conditionTableHeader.map((headerName: string, index: number) => (
                <TableCell key={index} sx={{ py: 2, position: 'relative' }}>
                  <Typography component="span" fontSize="14px">
                    {headerName}
                  </Typography>
                  {index !== conditionTableHeader.length - 1 && <div className={classes.headerDivider} />}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {conditionDataSetup.map((row, index: number) => (
              <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell sx={{ py: 2 }}>
                  <Typography sx={{ fontWeight: 500, fontSize: '14px', width: '150px' }}>{row.fieldName}</Typography>
                </TableCell>
                <TableCell>
                  <Typography sx={{ width: '150px', fontSize: '14px' }}>{row.expectedValue}</Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.foundValue}>{row.foundValue}</Typography>
                </TableCell>
                <TableCell sx={{ py: 2 }}>
                  <Typography sx={{ color: row.foundValue === missingField ? '#CC0000' : '#333333', width: '150px' }}>
                    {row.reason}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
